import { LftLogotipo } from '@lift/design-system-react-web/dist/components';
import { Link } from 'react-router';
import { capitalizeFormatter } from '../../../../../utils/formatters/capitalize/capitalize.formatter';
import { CourseInfo } from '../../../../course-info/course-info.component';
import { AppHeaderLogoProps } from '../../../app-container.types';
import { getTipoDeCursoSelecionado, tiposCompletos } from '../../app-header.utils';

export const AppHeaderLogo: React.FC<AppHeaderLogoProps> = ({ mobile, isLead, parsedCurso, curso }) => {
  if (mobile) {
    if (isLead && !parsedCurso) return null;
    if (!isLead) {
      return (
        <CourseInfo
          courseType={getTipoDeCursoSelecionado(curso?.tipo ?? '')}
          courseName={capitalizeFormatter(curso?.nome)}
        />
      );
    }
    return (
      <CourseInfo
        courseType={parsedCurso?.tipo ? (tiposCompletos[parsedCurso.tipo]?.label ?? '') : ''}
        courseName={parsedCurso?.nome ?? ''}
      />
    );
  }
  return (
    <Link to="/">
      <LftLogotipo alt="Logotipo da marca" />
    </Link>
  );
};
